// @flow

export { InputPeruvianDocument } from './input-peruvian-document';
export { InputPeruvianZipcode } from './input-peruvian-zipcode';
export { InputPeruvianPhoneNumber } from './input-peruvian-phone-number';
